export type InputMask = 'date' | 'time' | 'siret'

export const MASK_LENGTH: Record<InputMask, number> = { date: 10, time: 5, siret: 17 }

const withSeparator = (digits: string, at: number, separator: string, deleting: boolean) =>
  digits.length > at || (digits.length === at && !deleting) ? separator : ''

export const applyMask = (mask: InputMask, value: string, deleting = false): string => {
  if (mask === 'siret') {
    const digits = value.replace(/\D/g, '').slice(0, 14)

    return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9), digits.slice(9)].filter(Boolean).join(' ')
  }
  if (mask === 'time') {
    const digits = value.replace(/\D/g, '').slice(0, 4)

    return digits.slice(0, 2) + withSeparator(digits, 2, ':', deleting) + digits.slice(2, 4)
  }

  const digits = value.replace(/\D/g, '').slice(0, 8)

  return (
    digits.slice(0, 2) +
    withSeparator(digits, 2, '/', deleting) +
    digits.slice(2, 4) +
    withSeparator(digits, 4, '/', deleting) +
    digits.slice(4, 8)
  )
}

export const parseFrenchDate = (value: string): Date | null => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value.trim())
  if (!match) return null
  const date = new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]))

  return date.getMonth() === Number(match[2]) - 1 ? date : null
}

export const isNotPast = (date: Date | null, today = new Date()): boolean =>
  !!date && date >= new Date(new Date(today).setHours(0, 0, 0, 0))
